// extracted by mini-css-extract-plugin
export default {"root":"_30UeY","priority-primary":"_3rys4","priorityPrimary":"_3rys4","disabled":"_1p6vv","priority-secondary":"_3B7Lb","prioritySecondary":"_3B7Lb"};